/**
 * @name ColorNumber
 * @description Componente de tipo tarjeta con color y numero
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CountUp from 'react-countup';

import { HelpTooltip } from '@components';
import { Card, Typography } from '@styles';

const ColorNumber = (props) => {
  const {
    color,
    delay,
    height,
    help,
    number,
    title
  } = props;

  return (
    <>
      <Paper height={height}>
        <ColorBar color={color} />
        <Container>
          <Header>
            <HeaderTitle>
              <Typography.H5>{title}</Typography.H5>
            </HeaderTitle>
            {help && (
              <HeaderAction>
                <HelpTooltip message={help} />
              </HeaderAction>
            )}
          </Header>
          <Content>
            <Data>
              <CountUp end={number} delay={delay ? delay : 2} />
            </Data>
          </Content>
        </Container>
      </Paper>
    </>
  );
};

ColorNumber.propTypes = {
  // Color de la tarjeta (Theme Colors).
  color: PropTypes.string.isRequired,
  // Segundos de delay para la animación CountUp. [Default: 2 seg]
  delay: PropTypes.number,
  // Altura de la tarjeta. [Default: 100%]
  height: PropTypes.number,
  // Mensaje de ayuda dentro del HelpTooltip.
  help: PropTypes.string,
  // Numero.
  number: PropTypes.any.isRequired,
  // Titulo.
  title: PropTypes.string.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Paper = styled(Card.Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const ColorBar = styled.div`
  //height: 100%;
  width: 8px;
  background-color: ${(props) => props.color};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Header = styled(Card.Header)`
  height: 42px;
`;

const HeaderTitle = styled(Card.HeaderTitle)`
  padding: 0 8px;
`;

const HeaderAction = styled(Card.HeaderAction)`
  padding: 0 8px;
  cursor: pointer;
`;

const Content = styled(Card.Content)`
  height: ${(props) => props.scroll ? 'calc(100% - 42.5px)' : ''};
`;

const Data = styled.div`
  padding: 0 8px;

  & > span {
    font-family: 'Bryant Pro Medium';
    font-size: 60px;
    line-height: 1;
  }
`;


export default ColorNumber;